import React from 'react';
import { ZapIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'gold' | 'ink';
  className?: string;
}
export function CtaButton({
  children,
  href = '#precio',
  size = 'lg',
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-3.5 text-sm sm:px-8 sm:py-5 sm:text-lg' : 'px-5 py-3 text-sm sm:px-6 sm:py-4 sm:text-base';
  const palette = variant === 'gold' ? 'bg-gold text-ink-900 hover:bg-gold-400 focus-visible:outline-gold' : 'bg-ink-800 text-cream hover:bg-ink-700 focus-visible:outline-ink-800';
  return <a href={href} className={`group inline-flex w-full max-w-xl items-center justify-center gap-2.5 rounded-xl font-sans font-bold uppercase tracking-wide shadow-lift transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${sizing} ${palette} ${className}`} data-id="element-49" data-mp="vbaay3d4l7sp">
      <ZapIcon className="h-4 w-4 shrink-0 sm:h-5 sm:w-5 transition-transform duration-200 ease-out group-hover:scale-110" aria-hidden="true" data-id="element-50" data-mp="39y7vvvpkf24g" />
      <span className="text-center leading-tight" data-id="element-51" data-mp="3f071zdcowd53">{children}</span>
    </a>;
}